import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGrid = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1 4.5C1 2.567 2.567 1 4.5 1C6.433 1 8 2.567 8 4.5C8 6.433 6.433 8 4.5 8C2.567 8 1 6.433 1 4.5Z",
			stroke: "#111111",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 15.5C1 13.567 2.567 12 4.5 12C6.433 12 8 13.567 8 15.5C8 17.433 6.433 19 4.5 19C2.567 19 1 17.433 1 15.5Z",
			stroke: "#111111",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 4.5C12 2.567 13.567 1 15.5 1C17.433 1 19 2.567 19 4.5C19 6.433 17.433 8 15.5 8C13.567 8 12 6.433 12 4.5Z",
			stroke: "#111111",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 15.5C12 13.567 13.567 12 15.5 12C17.433 12 19 13.567 19 15.5C19 17.433 17.433 19 15.5 19C13.567 19 12 17.433 12 15.5Z",
			stroke: "#111111",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgGrid);
export default ForwardRef;
